import powerReducer from "./reducers";

export default powerReducer;